<template>
  <div style="overflow: hidden">
    <div class="logo">
      <router-link to="/newHome">
        <img src="~@/assets/UniversityLogo.png" alt="">
        <span>内蒙古基层治理数据中心</span>
      </router-link>
    </div>
    <div class="user">
      <div class="username">
        {{ userInfo.realName }}
        <a
          href="javascript:;"
          @click="logout"
          style="color: #fff; font-size: 14px;margin-left: 20px;"
          >退出</a
        >
      </div>

      <!-- <div class="dept">
        <router-link to="/inputs_infoCenter" style="margin-right:20px;color: #fff; font-size: 14px">
          <img src="@/assets/infoIcon.png" alt=""> <span>消息</span>
        </router-link>
      </div> -->
    </div>
    <div class="nav" style="float:none">
      <div class="navList" style="text-align:center">
        <span v-for="(item,index) in userInfo.menuList" :key="index" >
          <router-link :to="item.url" :target="item.target=='menuItem'?'_self':'_blank'">{{item.menuName}}</router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { delCookie,setCookie, delSessionItem } from "../../../until/tools";
export default {
  data(){
    return{
      path:'',
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
  },
  methods: {
    logout() {
      var that = this;
      this.$confirm({
        title: "提示",
        content: "您确定要退出吗？",
        okText: "确定",
        cancelText: "取消",
        centered: true,
        onOk() {
          setCookie('loginTargetUrl',that.$route.path,{time:1});
          delCookie("bd_sid");
          delSessionItem("dims");
          that.$router.push("/inputs_account");
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1276px) {
   .ant-layout-header .nav .navList span {
      margin: 0 14px;
  }
}
</style>